<table mat-table
       [dataSource]="this.StructureMemberships"
       class="mat-elevation-z4 membership-mat-table"
       multiTemplateDataRows>
    <ng-container matColumnDef="MembershipName">
        <th mat-header-cell
            *matHeaderCellDef
            class="membership-name-mat-header-cell">
            {{this.MembershipNameHeaderText}}
        </th>
        <td mat-cell
            *matCellDef="let membership"
            class="membership-name-mat-cell">
            <form [formGroup]="membership.MembershipFormGroup"
                  class="membership-name-form">
                <mat-form-field class="membership-name-mat-form-field">
                    <mat-label>{{this.MembershipNameHeaderText}}</mat-label>

                    <input matInput
                           formControlName="membershipName"
                           placeholder="{{this.MembershipNameHeaderText}}"
                           [disabled]="false"
                           class="membership-name-mat-input" />
                </mat-form-field>
            </form>
        </td>
    </ng-container>

    <!-- Note:  the following column is not presently being used. -->
    <!--
    <ng-container matColumnDef="StructureName">
        <th mat-header-cell
            *matHeaderCellDef
            class="structure-name-mat-header-cell">
            {{this.StructureNameHeaderText}}
        </th>
        <td mat-cell
            *matCellDef="let membership"
            class="structure-name-mat-cell">
            <ng-container *ngIf="!this.UseStandardStructureName">
                <form [formGroup]="membership.membershipFormGroup"
                      class="membership-copy-name-form">
                    <mat-form-field class="membership-copy-name-mat-form-field">
                        <mat-label>Copy Name</mat-label>

                        <input matInput
                               formControlName="membershipStructureName"
                               placeholder="{{this.StructureNameHeaderText}}"
                               [disabled]="this.MembershipObjectNameDisabled(membership)"
                               class="membership-copy-name-mat-input" />
                    </mat-form-field>
                </form>
            </ng-container>

            <ng-container *ngIf="this.UseStandardStructureName">
                <span class="membership-copy-name-span">{{this.StandardStructureName}}</span>
            </ng-container>
        </td>
    </ng-container>
    -->

    <ng-container matColumnDef="RoleNames">
        <th mat-header-cell
            *matHeaderCellDef
            class="membership-roles-mat-header-cell">
            Role Name(s)
        </th>

        <td mat-cell
            *matCellDef="let membership"
            class="membership-roles-mat-cell">

            <!--[floatLabel]="'always'"-->
            <form [formGroup]="membership.MembershipFormGroup"
                  class="membership-roles-mat-cell">
                <mat-form-field appearance="fill"
                                class="membership-role-names-mat-form-field">
                    <mat-label class="scheduled-time-label">Role(s)</mat-label>

                    <mat-select multiple
                                formControlName="membershipRoleNames"
                                [disabled]="false"
                                class="scheduled-time-mat-select">
                        <mat-option *ngFor="let roleName of membership.AvailableRoleNames"
                                    [value]="roleName">
                            {{roleName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </td>
    </ng-container>

    <!--
    <ng-container matColumnDef="MemberType">
        <th mat-header-cell
            *matHeaderCellDef
            class="member-type-mat-header-cell">
            Member Type(s)
        </th>
        <td mat-cell
            *matCellDef="let membership"
            class="member-type-mat-cell">
            {{this.getMemberType(membership)}}
        </td>
    </ng-container>
    -->

    <ng-container matColumnDef="Member">
        <th mat-header-cell
            *matHeaderCellDef
            class="member-type-mat-header-cell">
            Member(s)
        </th>
        <td mat-cell
            *matCellDef="let membership"
            class="member-type-mat-cell">
            {{this.getMemberDisplayName(membership)}}
        </td>
    </ng-container>

    <ng-container matColumnDef="Action">
        <th mat-header-cell
            *matHeaderCellDef
            class="action-mat-header-cell">
            Actions
        </th>
        <td mat-cell
            *matCellDef="let membership"
            class="action-mat-cell">
            <mat-checkbox [(ngModel)]="membership.membershipSelected"
                          (ngModelChange)="this.membershipSelectionChanged(membership)"
                          class="membership-selected-mat-checkbox"
                          [matTooltipPosition]="this.TooltipPosition"
                          matTooltip="{{this.MembershipSelectionCheckboxTooltip}}"></mat-checkbox>

            <mat-icon svgIcon="bootstrap-arrows-expand"
                      class="arrows-expand-mat-icon"
                      (click)="this.arrowsExpandClicked(membership,$event)"
                      [matTooltipPosition]="this.TooltipPosition"
                      matTooltip="{{this.MembershipShowHideDetailTooltip(membership)}}"></mat-icon>

            <mat-icon svgIcon="trash"
                      class="membership-trash-mat-icon"
                      (click)="this.deleteMembership(membership)"
                      [matTooltipPosition]="this.TooltipPosition"
                      matTooltip="{{this.MembershipTrashCanTooltip}}"></mat-icon>
        </td>
    </ng-container>

    <!-- Expanded detail row (a second template). -->
    <ng-container matColumnDef="expandedDetail">
        <td mat-cell
            *matCellDef="let membership"
            [attr.colspan]="4"
            class="{{this.MembershipDetailTdClass(membership)}}">
            <div>
                <table>
                    <tr *ngFor="let member of membership.members; let mi=index">
                        <!-- Note:  the first <td/> is left blank on purpose. -->
                        <td class="expanded-detail-empty-structure-name-td"></td>

                        <td class="expanded-detail-member-detail-td">
                            <span class="expanded-detail-member-detail-span">{{this.MemberDetailText(member)}}</span>
                        </td>

                        <td class="expanded-detail-member-type-td">
                            <span class="expanded-detail-member-type-span">{{this.MemberTypeText(member)}}</span>
                        </td>

                        <td class="expanded-detail-member-actions-td">
                            <div class="expanded-detail-member-actions-div">
                                <div class="expanded-detail-member-actions-blank-space-div"></div>

                                <ng-container *ngIf="this.MemberCanMoveUp(membership, member, mi)">
                                    <mat-icon class="move-member-up-mat-icon"
                                              (click)="this.moveMemberUp(membership, member, mi)"
                                              [matTooltipPosition]="this.TooltipPosition"
                                              matTooltip="{{this.MoveMemberUpTooltip}}">arrow_upward</mat-icon>
                                </ng-container>
                                <ng-container *ngIf="this.MemberCanMoveDown(membership, member, mi)">
                                    <mat-icon class="move-member-down-mat-icon"
                                              (click)="this.moveMemberDown(membership, member, mi)"
                                              [matTooltipPosition]="this.TooltipPosition"
                                              matTooltip="{{this.MoveMemberDownTooltip}}">arrow_downward</mat-icon>
                                </ng-container>

                                <mat-icon svgIcon="trash"
                                          class="member-trash-mat-icon"
                                          (click)="this.deleteMember(membership, member, mi)"
                                          [matTooltipPosition]="this.TooltipPosition"
                                          matTooltip="{{this.DeleteMemberTooltip}}"></mat-icon>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </td>
    </ng-container>

    <!-- Define the grid's row header. -->
    <mat-header-row *matHeaderRowDef="this.MembershipTableColumnNames"></mat-header-row>

    <!-- Define the grid's row data. -->
    <mat-row *matRowDef="let row; columns: this.MembershipTableColumnNames"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedDetail']"
             class="{{this.MemberDetailRowClass(row)}}">
    </mat-row>
</table>

